import { render, staticRenderFns } from "./RewardView.vue?vue&type=template&id=21c26320&scoped=true&"
import script from "./RewardView.vue?vue&type=script&lang=js&"
export * from "./RewardView.vue?vue&type=script&lang=js&"
import style0 from "./RewardView.vue?vue&type=style&index=0&id=21c26320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c26320",
  null
  
)

export default component.exports